<header class="header" [class.over]="showInfoContent">

    <mat-toolbar style="background-color: #0D4F8B !important;" class="top-toolbar"
        [class.mat-elevation-z2]="settings.fixedHeader">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
            <div fxLayout="row" fxLayoutAlign="center center">
                <h6 fxLayout="row" fxLayoutAlign="start center" class="logo" ngClass.xs="mobile">
                    <img src="assets/logo.png" alt="logo"> &nbsp;&nbsp;
                    <img src="assets/SLA-Logo-1.jpg" alt="logo">
                    <span class="mx-2"><b>AICTE - Student Learning Assessment</b></span>
                </h6>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <div fxLayout="row" fxLayoutAlign="start center" fxShow="false" fxShow.gt-xs class="search-bar">
                <a fxLayout="row" fxLayoutAlign="start center" href="assets/data/scheme_doc.pdf" target="_blank"
                    ngClass.xs="mobile">
                    <span class="mx-2">
                        <font color="white">Scheme Document</font>
                    </span>
                </a>
                <a fxLayout="row" fxLayoutAlign="start center" href="assets/data/user_manual.pdf" target="_blank"
                    ngClass.xs="mobile">
                    <span class="mx-2">
                        <font color="white">User Manual</font>
                    </span>
                </a>
                <a [routerLink]="['/login']" style="color: white">Login</a>

            </div>
        </div>
    </mat-toolbar>
</header>